// import { ActionsMenu } from '@web/components/ui/actions-menu';
import { ActionsMenu } from '@web/components/ui/actions-menu';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@web/components/ui/table';
import { cn } from '@web/lib/shadcn';

type BrandItem = {
  id: string;
  name: string;
  organizationId: string;
  email: string | null;
  isDefault: boolean;
  address: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  phone: string | null;
  website: string | null;
};

type BrandsTableProps = {
  brands: BrandItem[];
  onDetails: (brand: BrandItem) => void;
  onDelete: (args: { id: string }) => Promise<void>;
};

export function BrandsTable({
  brands,
  onDetails,
  onDelete,
}: Readonly<BrandsTableProps>) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead>Phone</TableHead>
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>

      <TableBody>
        {brands.map((brand) => (
          <TableRow
            key={brand.id}
            className={cn(
              brand.isDefault &&
                'border-l-4 border-l-green-500 bg-green-50 hover:bg-green-100',
            )}
          >
            <TableCell
              className={cn(
                'font-medium',
                brand.isDefault && 'font-semibold text-green-700',
              )}
            >
              {brand.name}
              {brand.isDefault && (
                <span className="ml-2 rounded-full bg-green-100 px-2 py-0.5 text-xs text-green-600">
                  Default
                </span>
              )}
            </TableCell>
            <TableCell>{brand.phone}</TableCell>
            <TableCell className="text-right">
              <ActionsMenu
                actions={{
                  details: () => {
                    onDetails(brand);
                  },

                  delete: async () => {
                    await onDelete(brand);
                  },
                }}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
